import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

let params;

function init() {
    initPopOver();
    $(document).on("dblclick", "#tblApproveCourseRequest tbody tr", goToCourse);

    $(document).on("click", "#tblApproveCourseRequest .btnCourseApprove", function(e) {
        setCourseRequestApproval(e.target, true);
    });

    $(document).on("click", ".btnCourseReject", function(e) {
        setCourseRequestApproval(e.target, false);
    });

    $(document).on("click", ".btnStartCourseReject", hideAndShowCoursePopovers);

    $(document).on("click", ".btnCourseCancelReject", hideCoursePopover);

    $("#chkSearchAllCourseRequestsPendingApproval").click(getCourseRequestsPendingApproval);
}
function goToCourse() {
    forms.showSpinner();
    window.location.href = application.baseUrl + "/course/index/" + $(this).attr("courseId");
}

function hideAndShowCoursePopovers(e) {
    $(".btnStartCourseReject")
        .not($(this))
        .popover("hide");
    $(".btnStartCourseReject").popover();
}

function hideCoursePopover(e) {
    const courseRequestId = $(e.target).attr("courseRequestId");
    $("#btnStartRejectCourseRequest-" + courseRequestId).popover("hide");
}

function initPopOver() {
    $(".btnStartCourseReject").popover({
        container: "#divApproveCourseRequests",
        html: true,
        sanitize: false,
        animation: true,
        placement: "right",
        template:
            "<div class='popover' role='tooltip'><div class='arrow'> </div><h3 class='popover-header'></h3><div class='popover-body'></div></div>"
    });
}

function getCourseRequestsPendingApproval() {
    const checkBox = $("#chkSearchAllCourseRequestsPendingApproval");
    checkBox.prop("disabled", true).addClass("disabled");
    dataaccess
        .get({
            url: "/courses/RequestsPendingApproval/" + $(this).is(":checked"),
            accept: "text/html; charset=utf-8",
            dataType: "text/html"
        })
        .done(function(result) {
            $("#divApproveCourseRequests").html(result);
            initPopOver();
            setApproveCourseRequestTableVisibleAndCourseRequestsToApproveCount();
        })
        .always(function() {
            checkBox.prop("disabled", false).removeClass("disabled");
        });
}

function setCourseRequestApproval(target, isApproved) {
    const courseRequestId = $(target).attr("courseRequestId");
    let rejectedComment;
    params = {
        data: { isApproved: isApproved },
        url: "/Courses/CourseRequestApproval/" + courseRequestId
    };
    if (!isApproved) {
        rejectedComment = $("#txtCourseRejectReason-" + courseRequestId).val();
        if (!rejectedComment) {
            $("#divCourseValidationWarning-" + courseRequestId).removeClass("hidden");
            return;
        }
        $("#divCourseValidationWarning-" + courseRequestId).addClass("hidden");
        params.data.rejectedComment = rejectedComment;
    }

    dataaccess
        .put(params)
        .done(function() {
            $(".btnStartCourseReject").popover("hide");
            $("#tblApproveCourseRequest [courseRequestId=" + courseRequestId + "]").remove();
            const $hdnCourseRequestsToApproveCount = $("#hdnCourseRequestsToApproveCount");
            $hdnCourseRequestsToApproveCount.val($hdnCourseRequestsToApproveCount.val() - 1);
            setApproveCourseRequestTableVisibleAndCourseRequestsToApproveCount();
            services.notificationService.success(
                isApproved
                    ? "Successfully Approved Course Request."
                    : "Successfully Rejected Course Request."
            );
        })
        .fail(function() {
            $(".btnStartCourseReject").popover("hide");
        });
}

function setApproveCourseRequestTableVisibleAndCourseRequestsToApproveCount() {
    const requestsLeft = $("#hdnCourseRequestsToApproveCount").val();
    $("[approveCourseRequestBadge]").text(!requestsLeft ? "0" : requestsLeft);
    if (requestsLeft || parseInt(requestsLeft) > 0) {
        $("#divNoCourseRequestsToApprove").addClass("hidden");
        $("#divApproveCourseRequests").removeClass("hidden");
        return;
    }
    $("#divNoCourseRequestsToApprove").removeClass("hidden");
    $("#divApproveCourseRequests").addClass("hidden");
}

export const dashboardApproveCourseRequest = {
    init: init
};
